import { InjectionToken } from '@angular/core';
import type { FirebaseApp as FirebaseAppInstance } from 'firebase/app';

export { FirebaseError, initializeApp } from 'firebase/app';

/** The default Firebase app, created once in `firebaseProviders`. */
export const FirebaseApp = new InjectionToken<FirebaseAppInstance>(
  'FirebaseApp'
);
export type FirebaseApp = FirebaseAppInstance;
